import { Dispatcher } from 'flux';

var AppDispatcher = new Dispatcher();

export default AppDispatcher;
